
<template id="tagBreadcrumb">
  <div
    class="tags-view-container"
    v-show="visitedViews.length >= 0"
    style="overflow: hidden"
  >
    <div class="tabViewClass">
      <transition-group name="list" tag="div" class="tabViewClass-container">
        <div
          class="item"
          v-for="tag in Array.from(visitedViews)"
          :key="tag.path"
          @click="goRouterLink(tag)"
          :class="tag.path === editableTabsValue ? 'tab-action' : ''"
        >
          <p>{{ tag.title }}</p>
          <div class="detele-btn">
            <span
              @click.stop="delSelectTag(tag.path)"
              class="el-icon-circle-close"
            ></span>
          </div>
        </div>
      </transition-group>
      <div class="delete-btn el-icon-delete" @click="closeAllTags"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tagBreadcrumb",
  data() {
    return {
      editableTabsValue: "/",
      closableB: false,
    };
  },
  computed: {
    visitedViews() {
      //store中取值
      return this.$store.state.tagsview.visitedviews;
    },
  },
  methods: {
    goRouterLink(tab, event) {
      if (this.$route.meta.title == tab.title) return false;
      this.$router.push({ path: tab.path });
    },
    handleTabsEdit(targetName, action) {},
    closeAllTags() {
      let This = this;
      this.$store.dispatch("delAllViews");
      this.$router.push("/home");
      let obj = {
        name: "home",
        path: "/home",
        title: "首页",
      };
      This.$store.state.tagsview.visitedviews.push(obj);
    },
    isActive(route) {
      return route.path == this.$route.path;
    },
    addViewTags() {
      let This = this;
      //路由改变时执行的方法
      if (this.$route.name) {
        const route = this.$route;
        this.$store.dispatch("addVisitedViews", route);
        this.editableTabsValue = this.$route.path;
        if (
          This.$store.state.tagsview.visitedviews.length == 1 &&
          This.$store.state.tagsview.visitedviews[0].path == "/home"
        ) {
          This.closableB = false;
        } else {
          This.closableB = true;
        }
      }
    },
    delSelectTag(routePath) {
      if(this.$store.state.tagsview.visitedviews.length === 1) return false;
      let This = this;
      let route = this.$store.state.tagsview.visitedviews.filter(
        (item) => item.path == routePath
      )[0];
      //先提交删除数据的方法,数组删除出掉数据后，如果关闭的是当前打开的路由需要将路由改为数组最后一次push进去的路由
      this.$store.dispatch("delVisitedViews", route).then((views) => {
        if (this.isActive(route)) {
          //只有在关闭当前打开的标签页才会有影响
          let lastView = views.slice(-1)[0]; //选取路由数组中的最后一位
          if (lastView) {
            this.$router.push(lastView);
            if (
              This.$store.state.tagsview.visitedviews.length == 1 &&
              This.$store.state.tagsview.visitedviews[0].path == "/home"
            ) {
              This.closableB = false;
            } else {
              This.closableB = true;
            }
          } else {
            this.$router.push("/");
            This.closableB = false;
          }
          This.editableTabsValue = route.path;
        } else {
          if (
            This.$store.state.tagsview.visitedviews.length == 1 &&
            This.$store.state.tagsview.visitedviews[0].path == "/home"
          ) {
            This.closableB = false;
          } else {
            This.closableB = true;
          }
        }
      });
    },
  },
  watch: {
    $route() {
      this.addViewTags();
    },
  },
};
</script>

<style>
.tags-view-container {
  padding-bottom: 14px;
}

.tabViewClass, .tabViewClass-container {  
  display: flex;
  align-items: center;
  justify-content: left;
}


.tabViewClass .item,
.tabViewClass .delete-btn {
  position: relative;
  height: 40px;
  background: #fff;
  border: 1px solid #e9e9e9;
  border-radius: 5px;
  overflow: hidden;
  cursor: pointer;

  padding: 0 16px;
  box-sizing: border-box;
  margin-right: 6px;

  font-size: 14px;
  line-height: 40px;
  text-align: center;
  color: #666;

  transition: all 0.4s;
}

.tab-action {
  color: #e07328 !important;
  border: 1px solid #e07328 !important;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 2px 6px;
}

.tabViewClass .item:hover {
  color: #e07328;
}

.tabViewClass .delete-btn:hover {
  color: #000;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 2px 6px;
}

.tabViewClass .item:hover {
  box-shadow: rgba(149, 157, 165, 0.2) 0px 2px 6px;
}

.tabViewClass .item .detele-btn {
  transition: all 0.6s;

  position: absolute;
  top: 0;
  right: -30px;
  width: 20px;
  height: 100%;

  display: flex;
  align-items: center;
  padding-left: 4px;

  background: linear-gradient(rgba(255, 255, 255, 0.2), rgb(255, 255, 255, 1));

  font-size: 16px;
}

.tabViewClass .item .detele-btn span {
  color: #666 !important;
}

.tabViewClass .item .detele-btn span:hover {
  color: #e07328 !important;
}

.tabViewClass .item:hover .detele-btn {
  right: 0;
}

.list-enter-active,
.list-leave-active {
  transition: all 1s;
}

.list-enter, .list-leave-to
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
</style>



// WEBPACK FOOTER //
// src/components/osNav/breadcrumb/tag-breadcrumb.vue